<ng-container class="container-stepper">
  <div class="box-detail mt-3" *ngIf="viewRequest !== 'Salud y Dental'">
    <div class="center-box">
      <span class="copec-bold-16">Detalle</span>
    </div>
    <div class="d-flex align-items-center">
      <button
        class="button-style2 button-isrejected copec-bold-14"
        (click)="goToRequest(idSelection)"
      >
        Ver Solicitud
      </button>
    </div>
  </div>
  <div class="progress-box">
    <mat-progress-bar
      mode="determinate"
      [value]="progressBarData.percent"
      [color]="progressBarData.colorProgressBar"
    ></mat-progress-bar>
    <div class="d-flex justify-content-between copec-rg-16">
      <span *ngFor="let step of steps" [class]="step.color"
        ><img class="me-2" [src]="step.iconUrl" alt=""  [ngStyle]="step.status === 'Anulada' ? {'width': '16px'} : {}"/>{{ step.name }}</span
      >
    </div>
  </div>
</ng-container>
